var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoNarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon",
    d: "M14.8978 13.343C14.8978 14.2175 14.6821 15.041 14.3016 15.7671H9.69699L8.05231 12.3107H14.7772C14.7749 12.2643 14.7702 12.2202 14.7656 12.1738C14.8514 12.5496 14.8978 12.9417 14.8978 13.343Z",
    fill: "url(#paint0_linear_2674_2427)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon",
    d: "M19.0177 15.086L18.9249 15.7656H14.2321C14.6102 15.0396 14.8213 14.2161 14.8213 13.3415C14.8213 12.9402 14.7749 12.5482 14.6914 12.1724C14.587 11.2375 13.9792 10.2656 13.4526 9.72971C12.8542 9.11963 12.142 8.66728 11.3649 8.39355C11.3371 8.38427 11.3092 8.37267 11.2814 8.3634C10.7293 8.18014 10.1494 8.08271 9.55319 8.08271C9.00341 8.08271 8.46524 8.1639 7.95258 8.32164H7.94794C7.91547 8.33092 7.88299 8.34252 7.8482 8.35412C7.02934 8.62321 6.28006 9.08947 5.65374 9.72739C4.57275 10.8293 4.03225 12.2744 4.03225 13.7196C4.03225 15.1648 4.57275 16.6123 5.65374 17.7119L9.55319 21.6832L12.3879 18.7975H18.1014L14.7007 22.2353L14.5963 22.3397L9.55319 27.4756L2.78889 20.5883C-0.929628 16.8002 -0.929628 10.639 2.78889 6.85094C4.59363 5.0114 6.99685 4 9.55319 4C10.8314 4 12.0701 4.25285 13.2184 4.73767C14.3643 5.22017 15.4151 5.93233 16.3175 6.85326C17.7952 8.35644 18.7277 10.2609 19.0177 12.3603C19.1429 13.2626 19.1429 14.1789 19.0177 15.0813V15.086Z",
    fill: "url(#paint1_linear_2674_2427)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2674_2427",
    x1: 6.9342,
    y1: 13.9693,
    x2: 14.9813,
    y2: 13.9693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0077FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2674_2427",
    x1: 9.55551,
    y1: 27.8027,
    x2: 9.55551,
    y2: 3.93041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0077FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNarrow);
export default __webpack_public_path__ + "static/media/logo-narrow.414906265c0a5cd8e3b824aee20a8c0f.svg";
export { ForwardRef as ReactComponent };